import React, {useContext} from 'react'
import styled from 'styled-components'

import {StateContext} from '../../utils/context'

export default () => {
  const {state} = useContext(StateContext)

  return (
    <Container>
      <FirstGrid>
        {state.isMobile ? null : <Copyright>© 2020, made by Rhapsodist</Copyright>}
      </FirstGrid>
      <SecondGrid>

      </SecondGrid>
      <ThirdGrid>
        {state.isMobile ? <Copyright>© 2020, made by Rhapsodist</Copyright> : null}
      </ThirdGrid>
    </Container>
  )
}

const Container = styled.div`
  position: static;
  bottom: 0;
  width: 100%;
  height: 15vh;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  background-color: ${props => props.theme.green};
  @media(min-width: 900px) {
    grid-template-rows: none;
    grid-template-columns: 1fr 1fr 1fr;
  }
`
const BaseGrid = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
const FirstGrid = styled(BaseGrid)`
`
const Copyright = styled.p`
  color: ${props => props.theme.beige};
`
const SecondGrid = styled(BaseGrid)``
const ThirdGrid = styled(BaseGrid)``